import React, { useState } from 'react';
import './AntiFraudWarning.css'; // Fichier CSS pour les styles

const AntiFraudWarning = ({ style = {} }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Utilisation de FontAwesome ou autre bibliothèque d'icônes web
  // Ici, nous utiliserons une classe CSS ou une bibliothèque comme react-icons
  const iconMap = {
    'Shield': 'fas fa-shield-alt',
    'Eye': 'fas fa-eye',
    'MapPin': 'fas fa-map-marker-alt',
    'CreditCard': 'fas fa-credit-card',
    'Phone': 'fas fa-phone',
    'AlertTriangle': 'fas fa-exclamation-triangle',
    'CheckCircle': 'fas fa-check-circle',
    'X': 'fas fa-times',
    'ExternalLink': 'fas fa-external-link-alt',
    'Flag': 'fas fa-flag',
    'MessageCircle': 'fas fa-comment-alt',
    'ChevronUp': 'fas fa-chevron-up',
    'ChevronDown': 'fas fa-chevron-down',
  };

  const getIconName = (iconKey) => {
    return iconMap[iconKey] || 'fas fa-question-circle';
  };

  const safetyTips = [
    {
      icon: 'Eye',
      title: 'Inspectez avant d\'acheter',
      description: 'Examinez toujours la pièce physiquement avant de payer. Vérifiez son authenticité et son état.'
    },
    {
      icon: 'MapPin',
      title: 'Rencontrez-vous dans des lieux sûrs',
      description: 'Privilégiez les lieux publics ou l\'adresse professionnelle enregistrée du vendeur. Évitez les endroits isolés.'
    },
    {
      icon: 'CreditCard',
      title: 'Moyens de paiement sécurisés',
      description: 'Utilisez des moyens de paiement sécurisés. Évitez les virements bancaires ou les paiements vers des comptes inconnus.'
    },
    {
      icon: 'Shield',
      title: 'Vérifiez l\'identité du vendeur',
      description: 'Vérifiez les badges de certification du vendeur et lisez les avis des autres acheteurs.'
    },
    {
      icon: 'Phone',
      title: 'Communication directe',
      description: 'Communiquez directement avec le vendeur via WhatsApp ou téléphone. Évitez les intermédiaires.'
    },
    {
      icon: 'AlertTriangle',
      title: 'Écoutez votre instinct',
      description: 'Si quelque chose semble suspect ou trop beau pour être vrai, écoutez votre instinct et passez votre chemin.'
    }
  ];

  const warningSignals = [
    'Le vendeur refuse de se rencontrer en personne',
    'Demande de paiement avant inspection',
    'Prix significativement inférieur au marché',
    'Photos de mauvaise qualité ou absence de photos',
    'Le vendeur n\'a pas de badges de vérification',
    'Pression pour acheter immédiatement',
    'Demande de moyens de paiement inhabituels'
  ];

  const handleEmergencyCall = () => {
    window.location.href = 'tel:117';
  };

  const handleReadSafetyGuide = () => {
    window.open('https://autocasse.cm/safety-guide', '_blank');
  };

  const handleReportIssue = () => {
    console.log('Navigation vers l\'écran de signalement');
    // Navigation vers la page de signalement
  };

  return (
    <div className="anti-fraud-warning" style={style}>
      {/* En-tête */}
      <div className="anti-fraud-header">
        <div className="anti-fraud-icon-container">
          <i className={getIconName('Shield')}></i>
        </div>
        <div className="anti-fraud-header-content">
          <h3 className="anti-fraud-title">Restez en sécurité pendant vos achats</h3>
          <p className="anti-fraud-subtitle">
            AutoCasse s'engage pour votre sécurité. Suivez ces conseils pour vous protéger contre la fraude.
          </p>
        </div>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="anti-fraud-expand-button"
          aria-expanded={isExpanded}
        >
          <i className={isExpanded ? getIconName('ChevronUp') : getIconName('ChevronDown')}></i>
        </button>
      </div>

      {/* Conseils rapides */}
      <div className="anti-fraud-quick-tips">
        <div className="anti-fraud-quick-tip">
          <i className={getIconName('Eye')}></i>
          <span className="anti-fraud-quick-tip-text">Inspectez avant de payer</span>
        </div>
        <div className="anti-fraud-quick-tip">
          <i className={getIconName('MapPin')}></i>
          <span className="anti-fraud-quick-tip-text">Rencontrez-vous dans des lieux publics</span>
        </div>
      </div>

      {/* Contenu déployé */}
      {isExpanded && (
        <div className="anti-fraud-expanded-content">
          {/* Conseils de sécurité */}
          <div className="anti-fraud-section">
            <div className="anti-fraud-section-header">
              <i className={getIconName('CheckCircle')}></i>
              <h4 className="anti-fraud-section-title">Conseils de sécurité</h4>
            </div>
            <div className="anti-fraud-safety-tips-grid">
              {safetyTips.map((tip, index) => (
                <div key={index} className="anti-fraud-safety-tip">
                  <i className={`${getIconName(tip.icon)} anti-fraud-tip-icon`}></i>
                  <div className="anti-fraud-tip-content">
                    <h5 className="anti-fraud-tip-title">{tip.title}</h5>
                    <p className="anti-fraud-tip-description">{tip.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Signaux d'alerte */}
          <div className="anti-fraud-section">
            <div className="anti-fraud-section-header">
              <i className={getIconName('AlertTriangle')}></i>
              <h4 className="anti-fraud-section-title">Signaux d'alerte à surveiller</h4>
            </div>
            <div className="anti-fraud-warning-signals-grid">
              {warningSignals.map((signal, index) => (
                <div key={index} className="anti-fraud-warning-signal">
                  <i className={getIconName('X')}></i>
                  <span className="anti-fraud-warning-signal-text">{signal}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Contact d'urgence */}
          <div className="anti-fraud-emergency-section">
            <div className="anti-fraud-section-header">
              <i className={getIconName('Phone')}></i>
              <h4 className="anti-fraud-section-title">Signaler une activité suspecte</h4>
            </div>
            <p className="anti-fraud-emergency-text">
              Si vous rencontrez un comportement suspect ou une fraude potentielle, signalez-le immédiatement.
            </p>
            <div className="anti-fraud-emergency-buttons">
              <button
                className="anti-fraud-button anti-fraud-emergency-button"
                onClick={handleEmergencyCall}
              >
                <i className={getIconName('Phone')}></i>
                <span>Urgence : 117</span>
              </button>
              <button
                className="anti-fraud-button anti-fraud-report-button"
                onClick={handleReportIssue}
              >
                <i className={getIconName('MessageCircle')}></i>
                <span>Signaler à AutoCasse</span>
              </button>
            </div>
          </div>

          {/* Protection AutoCasse */}
          <div className="anti-fraud-protection-section">
            <i className={getIconName('Shield')}></i>
            <div className="anti-fraud-protection-content">
              <h5 className="anti-fraud-protection-title">Protection AutoCasse</h5>
              <p className="anti-fraud-protection-text">
                Nous vérifions l'identité des vendeurs et surveillons les annonces pour détecter les activités suspectes.
                Notre équipe est disponible 24h/24 et 7j/7 pour vous assister en cas de problème.
              </p>
              <div className="anti-fraud-protection-features">
                <span className="anti-fraud-protection-feature">✓ Vérification d'identité</span>
                <span className="anti-fraud-protection-feature">✓ Support 24h/24 7j/7</span>
                <span className="anti-fraud-protection-feature">✓ Détection de fraude</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Boutons d'action */}
      {/* 
      <div className="anti-fraud-action-buttons">
        <button
          className="anti-fraud-link-button"
          onClick={handleReadSafetyGuide}
        >
          <span>Lire le guide de sécurité complet</span>
          <i className={getIconName('ExternalLink')}></i>
        </button>
        
        <button
          className="anti-fraud-report-issue-button"
          onClick={handleReportIssue}
        >
          <i className={getIconName('Flag')}></i>
          <span>Signaler un problème</span>
        </button>
      </div>
      */}
    </div>
  );
};

export default AntiFraudWarning;